import { useEffect } from "react";
import { toast } from "sonner";

const ZONE = [
  '[data-testid="import-docs-dropzone"]',
  '[data-testid="cliente-upload-zone"]',
  '[data-testid="ana-upload-zone"]',
  '[data-testid="pratica-campi-dropzone"]',
  '[data-testid="com-drop"]',
  '[data-testid="upload-pick"]',
].join(",");

// Il browser, di sua iniziativa, apre o scarica i file trascinati su una pagina (su macOS
// compare "Salva con nome"). Qui il comportamento predefinito viene bloccato SEMPRE, in ogni
// punto dell'app: alcuni browser (Safari in particolare) non permettono di sapere durante il
// trascinamento se ci sono file, quindi non ci si può basare su quel controllo.
export default function DropGuard() {
  useEffect(() => {
    const editabile = (t) => !!t?.closest?.("input:not([type=file]), textarea, [contenteditable=true]");
    const conFile = (e) => {
      const dt = e.dataTransfer;
      if (!dt) return false;
      if (dt.files?.length) return true;
      const tipi = Array.from(dt.types || []).map((x) => String(x).toLowerCase());
      if (tipi.some((t) => t === "files" || t.includes("file"))) return true;
      return Array.from(dt.items || []).some((i) => i.kind === "file");
    };

    const onOver = (e) => { if (!editabile(e.target)) e.preventDefault(); };
    const onDrop = (e) => {
      const file = conFile(e);
      if (!file && editabile(e.target)) return; // trascinamento di testo in un campo: lasciamo fare
      e.preventDefault();
      e.stopPropagation();
      if (file && !e.target?.closest?.(ZONE)) {
        toast.info("Trascina il documento sull'area tratteggiata “Trascina qui i documenti” per caricarlo.");
      }
    };

    // fase di bubbling: le zone di caricamento hanno già gestito il file
    window.addEventListener("dragenter", onOver);
    window.addEventListener("dragover", onOver);
    window.addEventListener("drop", onDrop);
    document.addEventListener("dragover", onOver);
    document.addEventListener("drop", onDrop);
    return () => {
      window.removeEventListener("dragenter", onOver);
      window.removeEventListener("dragover", onOver);
      window.removeEventListener("drop", onDrop);
      document.removeEventListener("dragover", onOver);
      document.removeEventListener("drop", onDrop);
    };
  }, []);
  return null;
}
